/* global alert */

import React from 'react'
import PropTypes from 'prop-types'

export default class InvoiceItemEdit extends React.Component {

  static defaultProps = {
    invoiceItem: {
      name: null,
      quantity: null,
      rate: null,
      taxPercent: null
    }
  }

  static propTypes = {
    index: PropTypes.number.isRequired,
    invoiceItem: PropTypes.object,
    onSave: PropTypes.func.isRequired,
    style: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = this.getStateFromProps(props)
  }

  getStateFromProps = props => {
    return {
      name: props.invoiceItem.name || '',
      rate: props.invoiceItem.rate || null,
      quantity: props.invoiceItem.quantity || null,
      taxPercent: props.invoiceItem.taxPercent || null
    }
  }

  componentDidMount() {
    if (this.nameInput) {
      this.nameInput.focus()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.invoiceItem !== nextProps.invoiceItem) {
      this.setState(this.getStateFromProps(nextProps))
    }
  }

  handleNameChanged = event => {
    this.setState({
      name: event.target.value
    })
  }

  handleRateChanged = event => {
    this.setState({
      rate: parseFloat(event.target.value)
    })
  }

  handleTaxPercentChanged = event => {
    this.setState({
      taxPercent: parseInt(event.target.value)
    })
  }

  handleQuantityChanged = event => {
    this.setState({
      quantity: parseInt(event.target.value)
    })
  }

  handleAutocompleteUpdateInput = searchText => {
    this.setState({
      name: searchText
    })
  }

  handleSaveClicked = event => {
    event.preventDefault()
    const validationResult = this.validateInvoiceItemInput(this.state)
    if (validationResult.success) {
      this.props.onSave(this.state)
    }
    else {
      alert(validationResult.error)
    }
  }

  validateInvoiceItemInput = newInvoiceItem => {
    if (!newInvoiceItem.name) {
      return { error: 'Name field is required.' }
    }
    return { success: true }
  }

  render() {
    return (
      <div style={{ ...this.props.style, ...styles.container(this.props.index)}}>
        <input
          style={styles.input(250, true)}
          type='text'
          ref={input => this.nameInput = input}
          value={this.state.name}
          placeholder='Name'
          onChange={event => this.handleNameChanged(event)} />
        <input
          style={styles.input(75)}
          type='number'
          step='1'
          placeholder='Quantity'
          value={this.state.quantity}
          onChange={event => this.handleQuantityChanged(event)} />
        <input
          style={styles.input(75)}
          type='number'
          step='0.1'
          placeholder='Rate'
          value={this.state.rate}
          onChange={event => this.handleRateChanged(event)} />
        <input
          style={styles.input(75)}
          type='number'
          step='1'
          placeholder='Tax %'
          value={this.state.taxPercent}
          onChange={event => this.handleTaxPercentChanged(event)} />
        <div style={styles.actions}>
          <div onClick={this.handleSaveClicked} title='Save'>
            <i className='material-icons' style={styles.action}>done</i>
          </div>
        </div>
      </div>
    )
  }

}

const styles = {
  container: index => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: index % 2 ? 'rgba(251, 235, 201, 0.30)' : 'rgba(255, 255, 255, 0.01)',
    paddingTop: 4,
    paddingBottom: 4
  }),
  input: (width, isName) => ({
    fontSize: 14,
    padding: '7px 11px 7px 11px',
    backgroundColor: '#fefefe',
    borderRadius: 3,
    boxShadow: 'inset 0 2px 2px 0 rgba(0, 0, 0, 0.05)',
    border: 'solid 1px rgba(0, 0, 0, 0.12)',
    width,
    marginLeft: isName ? 0 : 0
  }),
  actions: {
    textAlign: 'right',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    width: 44
  },
  action: {
    cursor: 'pointer',
    fontSize: 18
  }
}



// WEBPACK FOOTER //
// ./src/settings/modules/invoiceItems/InvoiceItemEdit.js